export enum DocumentKind {
  Principal = 'Principal',
  Attachment = 'Attachment',
  Act = 'Act',
  Other = 'Other'
}
